// Central content bank for IIUTCStudy

export const BRAND = {
  name: "IIUTC Study",
  fullName: "International Institute of Unified Tech & Commerce",
  tagline: "Learn • Upskill • Grow • Succeed",
  phone: "+91 8919546695",
  whatsapp: "+91 8919546695",
  email: "contactus@iiutcstudy.com",
  address: "Unit 410, 4th Floor, Manjeera Majestic Commercial, KPHB, Kukatpally, JNTU–Hitex Madhapur Road, Hyderabad – 500085",
  hours: "Mon – Sat · 9:00 AM – 8:00 PM IST",
  social: {
    instagram: "https://www.instagram.com/iiutcstudy_official?igsh=Z3FzcnM2bWtjdjI2",
    linkedin: "https://linkedin.com",
    youtube: "https://youtube.com/@iiutcstudy?si=RQSY4Bzq6HHw_7fY",
    facebook: "https://facebook.com",
  },
};

export const STATS = [
  { value: 10000, suffix: "+", label: "Students Trained" },
  { value: 150, suffix: "+", label: "Expert Mentors" },
  { value: 50, suffix: "+", label: "Courses Offered" },
  { value: 500, suffix: "+", label: "Hiring Partners" },
  { value: 95, suffix: "%", label: "Placement Support" },
];

export const WHY_CHOOSE = [
  { icon: "GraduationCap", title: "Expert Faculty", desc: "Learn from industry veterans with 10+ years of proven experience." },
  { icon: "Video", title: "Live Interactive Classes", desc: "Real-time doubts, whiteboards, breakout rooms, weekly reviews." },
  { icon: "Cpu", title: "AI-Powered Learning", desc: "Adaptive learning paths and AI tutors for personalised progress." },
  { icon: "BookOpenCheck", title: "Industry Curriculum", desc: "Refreshed every quarter, aligned with hiring partner needs." },
  { icon: "Wrench", title: "Practical Projects", desc: "Ship 10+ real-world capstone projects across the program." },
  { icon: "Briefcase", title: "Internship Support", desc: "Guaranteed internship interviews with vetted partner companies." },
  { icon: "Handshake", title: "Placement Assistance", desc: "Dedicated placement cell working till you land the offer." },
  { icon: "FileText", title: "Resume Building", desc: "One-on-one resume, LinkedIn and portfolio reviews." },
  { icon: "MessageSquare", title: "Mock Interviews", desc: "Unlimited mock interviews with hiring managers." },
  { icon: "Compass", title: "Career Counseling", desc: "Free 1:1 career mapping session before you enroll." },
  { icon: "PiggyBank", title: "Affordable Fees", desc: "Zero-cost EMIs, scholarships and pay-after-placement plans." },
  { icon: "Clock", title: "Flexible Learning", desc: "Weekday, weekend and self-paced batches for working pros." },
];

export const COURSE_CATEGORIES = [
  {
    key: "software",
    title: "Software Development",
    icon: "Code2",
    color: "from-blue-600 to-indigo-600",
    blurb: "Full-stack engineering roles that pay top of market.",
    items: [
      "Full Stack Java", "MERN Stack", "MEAN Stack", "React.js", "Angular",
      "Node.js", "Express.js", "Spring Boot", "Java", "Python",
      "C Programming", "C++", "SQL", "MongoDB", "Oracle Database",
    ],
  },
  {
    key: "ai",
    title: "Artificial Intelligence",
    icon: "Sparkles",
    color: "from-rose-600 to-red-600",
    blurb: "Build production-grade GenAI, LLM and ML systems.",
    items: [
      "AI Fundamentals", "Prompt Engineering", "ChatGPT", "Generative AI",
      "Machine Learning", "Deep Learning", "LangChain", "LangGraph",
      "OpenAI APIs", "HuggingFace",
    ],
  },
  {
    key: "data",
    title: "Data Science",
    icon: "BarChart3",
    color: "from-cyan-600 to-blue-600",
    blurb: "Turn raw data into decisions with modern analytics.",
    items: [
      "Python", "NumPy", "Pandas", "Statistics", "SQL",
      "Tableau", "Power BI", "Data Analytics",
    ],
  },
  {
    key: "cloud",
    title: "Cloud Computing",
    icon: "Cloud",
    color: "from-indigo-600 to-purple-600",
    blurb: "Deploy, scale and secure workloads on the cloud.",
    items: [
      "AWS", "Microsoft Azure", "Google Cloud", "Docker", "Kubernetes", "DevOps",
    ],
  },
  {
    key: "security",
    title: "Cyber Security",
    icon: "ShieldCheck",
    color: "from-slate-800 to-blue-900",
    blurb: "Break in, defend, and lead security teams.",
    items: [
      "Ethical Hacking", "Network Security", "Penetration Testing",
      "SOC Analyst", "Kali Linux",
    ],
  },
  {
    key: "commerce",
    title: "Commerce & Business",
    icon: "Building2",
    color: "from-emerald-600 to-teal-700",
    blurb: "Finance, accounting and business ops for the modern world.",
    items: [
      "Accounting", "Finance", "GST", "Tally Prime", "Business Analytics",
      "Entrepreneurship", "Human Resources", "Digital Marketing",
    ],
  },
  {
    key: "entrepreneurship",
    title: "Entrepreneurship",
    icon: "Rocket",
    color: "from-orange-500 to-yellow-500",
    blurb: "Launch and grow a business from idea to first sale.",
    items: [
      "Business Fundamentals", "Entrepreneurship Fundamentals", "Online Business",
      "Freelancing", "Instagram Marketing", "Large Language Models (LLM)",
    ],
  },
  {
    key: "communication",
    title: "Communication",
    icon: "MessageCircle",
    color: "from-pink-500 to-red-500",
    blurb: "Speak, present and negotiate with confidence at work.",
    items: [
      "Business Communication", "Public Speaking", "Presentation Skills",
      "Negotiation", "Email Writing", "Interpersonal Skills",
    ],
  },
  {
    key: "sales",
    title: "Sales",
    icon: "Handshake",
    color: "from-lime-600 to-emerald-600",
    blurb: "Prospect, pitch and close with proven sales playbooks.",
    items: [
      "Sales Fundamentals", "B2B Sales", "B2C Sales", "Sales Negotiation",
      "CRM Management", "Customer Relationship Management",
    ],
  },
  {
    key: "business-strategy",
    title: "Business Strategy",
    icon: "Target",
    color: "from-violet-600 to-fuchsia-600",
    blurb: "Analyse markets and plan for sustainable growth.",
    items: [
      "Strategic Management", "Competitive Analysis", "Business Planning",
      "Market Analysis", "SWOT Analysis", "Growth Strategy",
    ],
  },
  {
    key: "operations",
    title: "Operations",
    icon: "Settings2",
    color: "from-stone-600 to-zinc-700",
    blurb: "Run supply chains and processes without the guesswork.",
    items: [
      "Operations Management", "Supply Chain Management", "Logistics",
      "Procurement", "Inventory Management", "Lean Six Sigma",
    ],
  },
  {
    key: "project-management",
    title: "Project Management",
    icon: "ClipboardList",
    color: "from-blue-600 to-teal-600",
    blurb: "Plan, run and deliver projects the Agile way.",
    items: [
      "Project Management Fundamentals", "Agile", "Scrum",
      "PMP Preparation", "Kanban", "Risk Management",
    ],
  },
  {
    key: "business-law",
    title: "Business Law",
    icon: "Gavel",
    color: "from-slate-600 to-neutral-800",
    blurb: "Contracts, compliance and the law every business needs.",
    items: [
      "Contract Law", "Intellectual Property", "Employment Law",
      "Business Ethics", "Legal Documentation",
    ],
  },
  {
    key: "hr",
    title: "Human Resources",
    icon: "UserCog",
    color: "from-teal-600 to-green-700",
    blurb: "Hire, engage and manage people the right way.",
    items: [
      "HR Management", "Recruitment", "Talent Acquisition",
      "Payroll Management", "Employee Engagement", "HR Analytics",
    ],
  },
  {
    key: "industry",
    title: "Industry",
    icon: "Factory",
    color: "from-amber-600 to-red-700",
    blurb: "Sector-specific know-how across manufacturing to energy.",
    items: [
      "Manufacturing", "Healthcare Industry", "Retail Industry",
      "Banking Industry", "Hospitality", "Construction",
    ],
  },
  {
    key: "ecommerce",
    title: "E-Commerce",
    icon: "ShoppingCart",
    color: "from-fuchsia-600 to-rose-600",
    blurb: "Build and scale an online store from scratch.",
    items: [
      "Shopify", "Amazon FBA", "WooCommerce", "Dropshipping",
      "Online Store Management", "E-Commerce Marketing",
    ],
  },
  {
    key: "media",
    title: "Media",
    icon: "Clapperboard",
    color: "from-indigo-600 to-purple-700",
    blurb: "Create, produce and publish content that gets seen.",
    items: [
      "Content Creation", "Video Production", "Podcasting",
      "Journalism", "Social Media Content", "Brand Storytelling",
    ],
  },
  {
    key: "real-estate",
    title: "Real Estate",
    icon: "Home",
    color: "from-emerald-600 to-cyan-700",
    blurb: "Invest, manage and value property with confidence.",
    items: [
      "Real Estate Investing", "Property Management", "Commercial Real Estate",
      "Real Estate Marketing", "Property Valuation", "Real Estate Finance",
    ],
  },
  {
    key: "other-business",
    title: "Other Business",
    icon: "Briefcase",
    color: "from-slate-500 to-slate-700",
    blurb: "Practical, workplace-ready skills for every role.",
    items: [
      "Business Writing", "Consulting", "Customer Service",
      "Office Productivity", "Business Research", "International Business",
    ],
  },
];

export const COUNTRIES = [
  { name: "USA", flag: "🇺🇸", universities: "Harvard, MIT, Stanford", work: "3-year OPT + STEM" },
  { name: "Canada", flag: "🇨🇦", universities: "Toronto, UBC, McGill", fees: "CAD 20k – 50k / yr", work: "PGWP up to 3 yrs" },
  { name: "United Kingdom", flag: "🇬🇧", universities: "Oxford, Cambridge, UCL", fees: "£15k – £38k / yr", work: "2-year Graduate Route" },
  { name: "Australia", flag: "🇦🇺", universities: "Melbourne, Sydney, ANU", fees: "AUD 22k – 45k / yr", work: "Post-study up to 4 yrs" },
  { name: "New Zealand", flag: "🇳🇿", universities: "Auckland, Otago", fees: "NZD 20k – 40k / yr", work: "Post-study 3 yrs" },
  { name: "Germany", flag: "🇩🇪", universities: "TUM, LMU, RWTH Aachen", fees: "€0 – €20k / yr", work: "18-month job seeker" },
  { name: "Ireland", flag: "🇮🇪", universities: "Trinity, UCD", fees: "€10k – €25k / yr", work: "2-year Stay Back" },
  { name: "France", flag: "🇫🇷", universities: "HEC, Sciences Po", fees: "€3k – €20k / yr", work: "1-year APS visa" },
  { name: "Singapore", flag: "🇸🇬", universities: "NUS, NTU, SMU", fees: "SGD 20k – 45k / yr", work: "Employment Pass" },
  { name: "UAE", flag: "🇦🇪", universities: "NYU AD, Khalifa", fees: "AED 40k – 90k / yr", work: "Green Visa 5 yrs" },
  { name: "Japan", flag: "🇯🇵", universities: "Tokyo, Kyoto", fees: "¥500k – ¥1.5M / yr", work: "Work permit friendly" },
  { name: "South Korea", flag: "🇰🇷", universities: "SNU, KAIST", fees: "₩4M – ₩12M / yr", work: "D-10 post-study" },
];

export const ABROAD_PROGRAMS = {
  ug: ["B.Tech", "B.Sc", "BBA", "BA", "B.Com"],
  pg: ["MBA", "MS", "M.Tech", "MSc", "MCA"],
  diploma: ["Information Technology", "Healthcare", "Hospitality", "Business"],
};

export const TESTS = ["IELTS", "TOEFL", "PTE", "GRE", "GMAT", "SAT", "ACT", "Duolingo English Test"];

export const ABROAD_SERVICES = [
  "Career Counseling", "Profile Evaluation", "University Selection",
  "SOP Writing", "LOR Guidance", "Scholarship Assistance",
  "Education Loan Support", "Visa Documentation", "Visa Interview Preparation",
  "Accommodation Assistance", "Airport Pickup", "Pre-Departure Guidance",
  "Post-Arrival Support",
];

export const UNIVERSITIES = [
  { name: "Harvard University", country: "USA", rank: "#1 QS", flag: "🇺🇸" },
  { name: "Stanford University", country: "USA", rank: "#5 QS", flag: "🇺🇸" },
  { name: "Massachusetts Institute of Technology", country: "USA", rank: "#1 THE", flag: "🇺🇸" },
  { name: "University of Oxford", country: "UK", rank: "#3 QS", flag: "🇬🇧" },
  { name: "University of Cambridge", country: "UK", rank: "#2 QS", flag: "🇬🇧" },
  { name: "University of Toronto", country: "Canada", rank: "#21 QS", flag: "🇨🇦" },
  { name: "University of Melbourne", country: "Australia", rank: "#14 QS", flag: "🇦🇺" },
  { name: "University of Sydney", country: "Australia", rank: "#19 QS", flag: "🇦🇺" },
  { name: "National University of Singapore", country: "Singapore", rank: "#8 QS", flag: "🇸🇬" },
  { name: "Technical University of Munich", country: "Germany", rank: "#28 QS", flag: "🇩🇪" },
];

export const SCHOLARSHIPS = [
  { title: "Merit Scholarships", desc: "Up to 100% tuition waivers for top academic profiles." },
  { title: "Government Scholarships", desc: "Chevening, Fulbright, DAAD, Erasmus+ and more." },
  { title: "University Scholarships", desc: "Institution-specific grants across 500+ universities." },
  { title: "Need-Based Scholarships", desc: "Support for students from underrepresented backgrounds." },
  { title: "Financial Aid", desc: "Assistantships, tuition loans and living stipends." },
];

// Unified, filterable catalog for the Study Abroad section (Countries, Programs, Test Prep, Scholarships)
export const ABROAD_FILTERS = ["All", "Countries", "Programs", "Test Prep", "Scholarships"];

export const ABROAD_CATEGORY_STYLES = {
  Countries: "bg-blue-50 text-blue-700",
  Programs: "bg-purple-50 text-purple-700",
  "Test Prep": "bg-indigo-50 text-indigo-700",
  Scholarships: "bg-emerald-50 text-emerald-700",
};

export const ABROAD_CATALOG = [
  // ---- Countries ----
  // { id: "c-usa", category: "Countries", badge: "Most Popular", info: "$25k – $60k / yr", flag: "🇺🇸", title: "United States", subtitle: "3-year OPT + STEM", desc: "Home to Ivy League and top-ranked STEM programs, with unmatched research funding and flexible major switching.", tags: ["Harvard", "MIT", "Stanford", "F-1 Visa"], primary: "Apply Now", featured: true },
  // { id: "c-can", category: "Countries", badge: "High Demand", info: "CAD 20k – 50k / yr", flag: "🇨🇦", title: "Canada", subtitle: "PGWP up to 3 yrs", desc: "Affordable tuition, welcoming immigration pathways, and strong co-op programs make it a top pick for long-term settlement.", tags: ["Toronto", "UBC", "McGill", "PGWP"], primary: "Apply Now" },
  // { id: "c-uk", category: "Countries", badge: "Trending", info: "£15k – £38k / yr", flag: "🇬🇧", title: "United Kingdom", subtitle: "2-year Graduate Route", desc: "One-year master's programs and centuries-old academic prestige, with a straightforward post-study work visa.", tags: ["Oxford", "Cambridge", "UCL", "Graduate Route"], primary: "Apply Now" },
  // { id: "c-aus", category: "Countries", badge: "Growing Fast", info: "AUD 22k – 45k / yr", flag: "🇦🇺", title: "Australia", subtitle: "Post-study up to 4 yrs", desc: "High quality of life, generous post-study work rights, and globally ranked universities across every major city.", tags: ["Melbourne", "Sydney", "ANU", "Post-Study Visa"], primary: "Apply Now" },
  // { id: "c-nz", category: "Countries", badge: "Emerging Choice", info: "NZD 20k – 40k / yr", flag: "🇳🇿", title: "New Zealand", subtitle: "Post-study 3 yrs", desc: "Small class sizes and a relaxed lifestyle, with clear pathways to residency after graduation.", tags: ["Auckland", "Otago", "PR Pathway"], primary: "Apply Now" },
  // { id: "c-ger", category: "Countries", badge: "Tuition-Free", info: "€0 – €20k / yr", flag: "🇩🇪", title: "Germany", subtitle: "18-month job seeker visa", desc: "Public universities charge little to no tuition, especially strong for engineering and applied sciences.", tags: ["TUM", "LMU", "RWTH Aachen", "Low Cost"], primary: "Apply Now" },
  // { id: "c-ire", category: "Countries", badge: "Fast Growing", info: "€10k – €25k / yr", flag: "🇮🇪", title: "Ireland", subtitle: "2-year Stay Back", desc: "A booming tech and pharma hub in the EU, with a generous stay-back visa for graduates.", tags: ["Trinity", "UCD", "EU Access"], primary: "Apply Now" },
  // { id: "c-fra", category: "Countries", badge: "Culture & Career", info: "€3k – €20k / yr", flag: "🇫🇷", title: "France", subtitle: "1-year APS visa", desc: "Low-cost public education paired with strong business and design schools in the heart of Europe.", tags: ["HEC", "Sciences Po", "APS Visa"], primary: "Apply Now" },
  // { id: "c-sgp", category: "Countries", badge: "Asia's Hub", info: "SGD 20k – 45k / yr", flag: "🇸🇬", title: "Singapore", subtitle: "Employment Pass eligible", desc: "A safe, English-speaking gateway to Asia's job market with top-ranked business and tech programs.", tags: ["NUS", "NTU", "SMU"], primary: "Apply Now" },
  // { id: "c-uae", category: "Countries", badge: "Quick Visa", info: "AED 40k – 90k / yr", flag: "🇦🇪", title: "UAE", subtitle: "Green Visa 5 yrs", desc: "Tax-free income and fast-track long-term visas at globally branded university campuses.", tags: ["NYU AD", "Khalifa", "Tax-Free"], primary: "Apply Now" },
  // { id: "c-jpn", category: "Countries", badge: "Tech Frontier", info: "¥500k – ¥1.5M / yr", flag: "🇯🇵", title: "Japan", subtitle: "Work permit friendly", desc: "Cutting-edge research and a growing number of English-taught programs at top technical universities.", tags: ["Tokyo", "Kyoto", "Innovation"], primary: "Apply Now" },
  // { id: "c-kor", category: "Countries", badge: "Rising Star", info: "₩4M – ₩12M / yr", flag: "🇰🇷", title: "South Korea", subtitle: "D-10 post-study visa", desc: "Scholarship-rich programs at globally ranked universities, with strong ties to tech and entertainment industries.", tags: ["SNU", "KAIST", "D-10 Visa"], primary: "Apply Now" },
  { id: "c-usa", category: "Countries", badge: "Most Popular", flag: "🇺🇸", title: "United States", subtitle: "3-year OPT + STEM", desc: "Home to Ivy League and top-ranked STEM programs, with unmatched research funding and flexible major switching.", tags: ["Harvard", "MIT", "Stanford", "F-1 Visa"], primary: "Apply Now", featured: true },

{ id: "c-can", category: "Countries", badge: "High Demand", flag: "🇨🇦", title: "Canada", subtitle: "PGWP up to 3 yrs", desc: "Affordable tuition, welcoming immigration pathways, and strong co-op programs make it a top pick for long-term settlement.", tags: ["Toronto", "UBC", "McGill", "PGWP"], primary: "Apply Now" },

{ id: "c-uk", category: "Countries", badge: "Trending", flag: "🇬🇧", title: "United Kingdom", subtitle: "2-year Graduate Route", desc: "One-year master's programs and centuries-old academic prestige, with a straightforward post-study work visa.", tags: ["Oxford", "Cambridge", "UCL", "Graduate Route"], primary: "Apply Now" },

{ id: "c-aus", category: "Countries", badge: "Growing Fast", flag: "🇦🇺", title: "Australia", subtitle: "Post-study up to 4 yrs", desc: "High quality of life, generous post-study work rights, and globally ranked universities across every major city.", tags: ["Melbourne", "Sydney", "ANU", "Post-Study Visa"], primary: "Apply Now" },

{ id: "c-nz", category: "Countries", badge: "Emerging Choice", flag: "🇳🇿", title: "New Zealand", subtitle: "Post-study 3 yrs", desc: "Small class sizes and a relaxed lifestyle, with clear pathways to residency after graduation.", tags: ["Auckland", "Otago", "PR Pathway"], primary: "Apply Now" },

{ id: "c-ger", category: "Countries", badge: "Tuition-Free", flag: "🇩🇪", title: "Germany", subtitle: "18-month job seeker visa", desc: "Public universities charge little to no tuition, especially strong for engineering and applied sciences.", tags: ["TUM", "LMU", "RWTH Aachen", "Low Cost"], primary: "Apply Now" },

{ id: "c-ire", category: "Countries", badge: "Fast Growing", flag: "🇮🇪", title: "Ireland", subtitle: "2-year Stay Back", desc: "A booming tech and pharma hub in the EU, with a generous stay-back visa for graduates.", tags: ["Trinity", "UCD", "EU Access"], primary: "Apply Now" },

{ id: "c-fra", category: "Countries", badge: "Culture & Career", flag: "🇫🇷", title: "France", subtitle: "1-year APS visa", desc: "Low-cost public education paired with strong business and design schools in the heart of Europe.", tags: ["HEC", "Sciences Po", "APS Visa"], primary: "Apply Now" },

{ id: "c-sgp", category: "Countries", badge: "Asia's Hub", flag: "🇸🇬", title: "Singapore", subtitle: "Employment Pass eligible", desc: "A safe, English-speaking gateway to Asia's job market with top-ranked business and tech programs.", tags: ["NUS", "NTU", "SMU"], primary: "Apply Now" },

{ id: "c-uae", category: "Countries", badge: "Quick Visa", flag: "🇦🇪", title: "UAE", subtitle: "Green Visa 5 yrs", desc: "Tax-free income and fast-track long-term visas at globally branded university campuses.", tags: ["NYU AD", "Khalifa", "Tax-Free"], primary: "Apply Now" },

{ id: "c-jpn", category: "Countries", badge: "Tech Frontier", flag: "🇯🇵", title: "Japan", subtitle: "Work permit friendly", desc: "Cutting-edge research and a growing number of English-taught programs at top technical universities.", tags: ["Tokyo", "Kyoto", "Innovation"], primary: "Apply Now" },

{ id: "c-kor", category: "Countries", badge: "Rising Star", flag: "🇰🇷", title: "South Korea", subtitle: "D-10 post-study visa", desc: "Scholarship-rich programs at globally ranked universities, with strong ties to tech and entertainment industries.", tags: ["SNU", "KAIST", "D-10 Visa"], primary: "Apply Now" },

  // ---- Programs ----
  { id: "p-ug", category: "Programs", badge: "Bachelor's", info: "3 – 4 Years", icon: "GraduationCap", title: "Undergraduate", subtitle: "Direct entry after 12th", desc: "Direct-entry bachelor's degrees across engineering, business, arts and sciences at partner universities worldwide.", tags: ["B.Tech", "B.Sc", "BBA", "BA", "B.Com"], primary: "Apply Now", featured: true },
  { id: "p-pg", category: "Programs", badge: "Master's", info: "1 – 2 Years", icon: "ScrollText", title: "Postgraduate", subtitle: "For graduates & professionals", desc: "Advanced master's and MBA programs built to fast-track your career, many with STEM-eligible curricula.", tags: ["MBA", "MS", "M.Tech", "MSc", "MCA"], primary: "Apply Now" },
  { id: "p-dip", category: "Programs", badge: "Certificate", info: "1 – 2 Years", icon: "BadgeCheck", title: "Diploma Courses", subtitle: "Fastest route to work abroad", desc: "Short, career-focused diploma tracks for faster entry into the workforce and a lower overall cost.", tags: ["Information Technology", "Healthcare", "Hospitality", "Business"], primary: "Apply Now" },

  // ---- Test Prep ----
  { id: "t-ielts", category: "Test Prep", badge: "Most Popular", title: "IELTS", subtitle: "Academic & General", desc: "The most widely accepted English test for UK, Canada and Australia visas, with Academic and General formats.", tags: ["Listening", "Reading", "Writing", "Speaking"], primary: "Book Demo", featured: true },
  { id: "t-toefl", category: "Test Prep", badge: "Widely Accepted", title: "TOEFL", subtitle: "Preferred for US universities", desc: "The go-to English test for US universities, fully computer-based with an integrated skills format.", tags: ["Reading", "Listening", "Speaking", "Writing"], primary: "Book Demo" },
  { id: "t-pte", category: "Test Prep", badge: "Fast Results", title: "PTE", subtitle: "Results in 48 hours", desc: "AI-scored test with results in under 48 hours — a favorite for Australia and New Zealand visas.", tags: ["Speaking", "Writing", "Reading", "Listening"], primary: "Book Demo" },
  { id: "t-gre", category: "Test Prep", badge: "Grad School", title: "GRE", subtitle: "For master's & PhD", desc: "Required for many master's and PhD programs in the US, testing verbal, quantitative and analytical writing skills.", tags: ["Verbal", "Quant", "AWA"], primary: "Book Demo" },
  { id: "t-gmat", category: "Test Prep", badge: "MBA Track", title: "GMAT", subtitle: "For MBA admissions", desc: "The standard test for MBA and business master's admissions, focused on quantitative and data insight skills.", tags: ["Quant", "Verbal", "Data Insights"], primary: "Book Demo" },
  { id: "t-sat", category: "Test Prep", badge: "Undergrad US", title: "SAT", subtitle: "For US undergrad admissions", desc: "A core requirement for many US undergraduate scholarships and direct-entry admissions.", tags: ["Math", "Reading", "Writing"], primary: "Book Demo" },
  { id: "t-act", category: "Test Prep", badge: "Undergrad Alt", title: "ACT", subtitle: "SAT alternative", desc: "An SAT alternative accepted by every US university, with an optional science reasoning section.", tags: ["English", "Math", "Science", "Reading"], primary: "Book Demo" },
  { id: "t-duo", category: "Test Prep", badge: "Budget Friendly", title: "Duolingo English Test", subtitle: "Take it from home", desc: "A low-cost, at-home English test accepted by a fast-growing list of universities worldwide.", tags: ["Adaptive", "At-Home", "Fast Results"], primary: "Book Demo" },

  // ---- Scholarships ----
  { id: "s-merit", category: "Scholarships", badge: "Up to 100%", info: "Academic", title: "Merit Scholarships", subtitle: "GPA & test-score based", desc: "Up to 100% tuition waivers for top academic profiles.", tags: ["GPA-Based", "Renewable"], primary: "Check Eligibility", featured: true },
  { id: "s-govt", category: "Scholarships", badge: "Fully Funded", info: "National", title: "Government Scholarships", subtitle: "Chevening, Fulbright & more", desc: "Chevening, Fulbright, DAAD, Erasmus+ and more government-funded awards.", tags: ["Chevening", "Fulbright", "DAAD"], primary: "Check Eligibility" },
  { id: "s-univ", category: "Scholarships", badge: "500+ Schools", info: "Institutional", title: "University Scholarships", subtitle: "Institution-specific grants", desc: "Institution-specific grants across 500+ universities worldwide.", tags: ["Need & Merit", "Institutional"], primary: "Check Eligibility" },
  { id: "s-need", category: "Scholarships", badge: "Inclusive", info: "Need-Based", title: "Need-Based Scholarships", subtitle: "For underrepresented backgrounds", desc: "Support for students from underrepresented and low-income backgrounds.", tags: ["Underrepresented", "Income-Based"], primary: "Check Eligibility" },
  { id: "s-aid", category: "Scholarships", badge: "Flexible", info: "Loans & Stipends", title: "Financial Aid", subtitle: "Assistantships & loans", desc: "Assistantships, tuition loans and living stipends to cover the gap.", tags: ["Assistantships", "Loans"], primary: "Check Eligibility" },
];

export const LEARNING_STEPS = [
  "Free Career Counseling", "Profile Evaluation", "Course Selection", "Registration",
  "Live Classes", "Practical Projects", "Certification", "Internship",
  "Resume Building", "Mock Interviews", "Placement Training", "Job Assistance",
  "Study Abroad Support", "Visa Processing", "Fly Abroad",
];

export const PROJECTS = [
  { title: "AI Chatbot", tag: "Generative AI", icon: "Bot" },
  { title: "Hospital Management System", tag: "Full Stack Java", icon: "Stethoscope" },
  { title: "E-Commerce Website", tag: "MERN Stack", icon: "ShoppingBag" },
  { title: "CRM Dashboard", tag: "React + Node", icon: "LayoutDashboard" },
  { title: "Banking Application", tag: "Spring Boot", icon: "Banknote" },
  { title: "Employee Management", tag: "Angular + .NET", icon: "Users" },
  { title: "Food Delivery App", tag: "React Native", icon: "UtensilsCrossed" },
  { title: "Inventory Management", tag: "Python + SQL", icon: "Package" },
  { title: "Student Portal", tag: "MEAN Stack", icon: "GraduationCap" },
];

export const CAREERS = [
  "Software Engineer", "Full Stack Developer", "Frontend Developer",
  "Backend Developer", "Java Developer", "Python Developer",
  "MERN Developer", "AI Engineer", "Machine Learning Engineer",
  "Data Analyst", "Data Scientist", "Cloud Engineer",
  "DevOps Engineer", "Cyber Security Analyst", "Business Analyst",
];

export const PARTNERS = [
  "Google", "Microsoft", "Amazon", "IBM", "Oracle",
  "Infosys", "TCS", "Wipro", "Cognizant", "Accenture",
  "Deloitte", "Capgemini", "Tech Mahindra", "HCL", "Zoho",
];

export const TESTIMONIALS = [
  {
    name: "Ananya Reddy",
    course: "Full Stack Java",
    company: "Amazon",
    pkg: "₹18 LPA",
    rating: 5,
    image: "https://images.pexels.com/photos/5538020/pexels-photo-5538020.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    quote:
      "The mentors were incredible. From my first line of Java to cracking Amazon SDE, IIUTCStudy walked with me at every step.",
  },
  {
    name: "Rohit Sharma",
    course: "MS in Computer Science",
    company: "University of Toronto",
    pkg: "50% Scholarship",
    rating: 5,
    image: "https://images.pexels.com/photos/36608621/pexels-photo-36608621.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    quote:
      "SOPs, visa prep, accommodation — everything was handled with care. I got into my dream school with a scholarship.",
  },
  {
    name: "Sneha Iyer",
    course: "Data Science",
    company: "Deloitte",
    pkg: "₹12 LPA",
    rating: 5,
    image: "https://images.unsplash.com/photo-1758270705172-07b53627dfcb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwyfHx1bml2ZXJzaXR5JTIwc3R1ZGVudHMlMjBkaXZlcnNlJTIwbW9kZXJuJTIwY2FtcHVzfGVufDB8fHx8MTc4Mjc1NzI2OHww&ixlib=rb-4.1.0&q=85",
    quote:
      "Real projects, live datasets, weekly reviews — I built confidence and a portfolio that got me hired in 3 months.",
  },
  {
    name: "Kunal Verma",
    course: "Cyber Security",
    company: "IBM",
    pkg: "₹14 LPA",
    rating: 5,
    image: "https://images.pexels.com/photos/5538020/pexels-photo-5538020.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    quote:
      "Hands-on labs on Kali Linux and mock SOC drills made the transition into security roles feel natural.",
  },
];

export const BLOGS = [
  { title: "AI Trends 2026: What Every Engineer Should Learn Next", tag: "AI Trends", date: "Feb 12, 2026", read: "6 min", img: "https://images.unsplash.com/photo-1758270705172-07b53627dfcb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwyfHx1bml2ZXJzaXR5JTIwc3R1ZGVudHMlMjBkaXZlcnNlJTIwbW9kZXJuJTIwY2FtcHVzfGVufDB8fHx8MTc4Mjc1NzI2OHww&ixlib=rb-4.1.0&q=85" },
  { title: "Study in Canada 2026 — Fees, PGWP & New Visa Rules", tag: "Study Abroad", date: "Feb 08, 2026", read: "8 min", img: "https://images.unsplash.com/photo-1496181133206-80ce9b88a853?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxzdHVkeWluZyUyMG1vZGVybiUyMGxhcHRvcHxlbnwwfHx8fDE3ODMyNjEwMTN8MA&ixlib=rb-4.1.0&q=85" },
  { title: "10 Portfolio Projects That Actually Get You Hired", tag: "Career Guidance", date: "Feb 02, 2026", read: "5 min", img: "https://images.pexels.com/photos/36608621/pexels-photo-36608621.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { title: "IELTS vs Duolingo — Which Test Should You Take in 2026?", tag: "Visa Updates", date: "Jan 27, 2026", read: "7 min", img: "https://images.pexels.com/photos/5538020/pexels-photo-5538020.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { title: "React 19 in Production — Server Components Cheatsheet", tag: "Programming", date: "Jan 20, 2026", read: "9 min", img: "https://images.unsplash.com/photo-1758270705172-07b53627dfcb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwyfHx1bml2ZXJzaXR5JTIwc3R1ZGVudHMlMjBkaXZlcnNlJTIwbW9kZXJuJTIwY2FtcHVzfGVufDB8fHx8MTc4Mjc1NzI2OHww&ixlib=rb-4.1.0&q=85" },
  { title: "Top 20 Fully-Funded Scholarships for Indian Students", tag: "Scholarship News", date: "Jan 14, 2026", read: "10 min", img: "https://images.unsplash.com/photo-1496181133206-80ce9b88a853?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxzdHVkeWluZyUyMG1vZGVybiUyMGxhcHRvcHxlbnwwfHx8fDE3ODMyNjEwMTN8MA&ixlib=rb-4.1.0&q=85" },
];

export const FAQS = [
  { q: "How do I enroll?", a: "Book a free counseling call from any Enroll or Consultation button. Our team will validate your profile, recommend a program and share the enrollment link with EMI options." },
  { q: "Do you provide certificates?", a: "Yes. Every program includes an industry-recognized IIUTCStudy certification plus additional partner certifications (AWS, Microsoft, Oracle, HuggingFace, etc.) where applicable." },
  { q: "Are classes online?", a: "We offer live online cohorts, hybrid batches and campus-based programs in select cities. Recordings and lifetime access are included with every program." },
  { q: "Is placement assistance available?", a: "Yes. Our placement cell partners with 500+ hiring companies. You get resume reviews, unlimited mock interviews and referrals until you land your offer." },
  { q: "Do you offer internships?", a: "Yes. Every technology program includes a guaranteed internship interview track with vetted partner companies." },
  { q: "Can you help with study abroad?", a: "Absolutely. We provide end-to-end support — university selection, SOP/LOR, scholarships, education loans, visa filing, accommodation and post-arrival help." },
  { q: "Which countries do you support?", a: "We actively support USA, Canada, UK, Australia, New Zealand, Germany, Ireland, France, Singapore, UAE, Japan and South Korea." },
  { q: "Do you provide visa guidance?", a: "Yes. Our visa team handles documentation, mock visa interviews and post-approval briefing for a smooth departure." },
];
